import { jsx as l, jsxs as Y } from "react/jsx-runtime";
import { c as Ce } from "react/compiler-runtime";
import { OutlinedInput as pe, Select as xe, Box as b, Typography as ye, Divider as Se, MenuItem as De } from "@mui/material";
import { useState as T, useEffect as me } from "react";
import m from "moment-timezone";
import { styles as n } from "./DateTimeSelect.style.js";
import Ie from "@mui/icons-material/EventOutlined";
import { DatePickerComponent as Ae } from "./DatePickerComponent.js";
import { TimePickerComponent as Ee } from "./TimePickerComponent.js";
const ce = m.months(), Pe = Array.from({
  length: 6
}, (s, e) => m().year() - e), ke = m().year(), _e = m().month(), Ge = (s) => {
  const e = Ce(72), {
    date: i,
    setDate: v,
    dateType: C,
    timeSlots: ee,
    isTimeHidden: I,
    minTime: te,
    maxTime: le,
    startDate: ne,
    endDate: oe
  } = s;
  let A;
  e[0] !== i ? (A = m.unix(i), e[0] = i, e[1] = A) : A = e[1];
  const t = A;
  let E;
  e[2] !== t ? (E = t.month().toString(), e[2] = t, e[3] = E) : E = e[3];
  const [c, fe] = T(E);
  let P;
  e[4] !== t ? (P = t.year().toString(), e[4] = t, e[5] = P) : P = e[5];
  const [o, he] = T(P), [r, ge] = T(i);
  let k;
  e[6] !== i ? (k = m.unix(i).format("h:mm A"), e[6] = i, e[7] = k) : k = e[7];
  const [a, Me] = T(k);
  let w;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (w = ce.slice(0, _e + 1), e[8] = w) : w = e[8];
  const [se, de] = T(w), ie = I ? "MMM DD, YYYY" : "MMM DD, YYYY hh:mm A";
  let j;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (j = (M) => {
    fe(M.target.value);
  }, e[9] = j) : j = e[9];
  const Ye = j;
  let B;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (B = (M) => {
    he(M.target.value);
  }, e[10] = B) : B = e[10];
  const be = B;
  let N, H;
  e[11] !== o ? (N = () => {
    parseInt(o) === ke ? de(ce.slice(0, _e + 1)) : de(ce);
  }, H = [o], e[11] = o, e[12] = N, e[13] = H) : (N = e[12], H = e[13]), me(N, H);
  let O, W;
  e[14] !== t ? (O = () => {
    fe(t.month().toString()), he(t.year().toString());
  }, W = [t], e[14] = t, e[15] = O, e[16] = W) : (O = e[15], W = e[16]), me(O, W);
  let z, F;
  e[17] !== r || e[18] !== a || e[19] !== v ? (z = () => {
    const [M, ue] = a.split(" "), [ae, Te] = M.split(":").map(Number);
    let Z = ae;
    ue === "PM" && ae < 12 && (Z = Z + 12), ue === "AM" && ae === 12 && (Z = 0);
    const ve = m.unix(r).hours(Z).minutes(Te).seconds(0).milliseconds(0);
    v(ve.unix());
  }, F = [r, a, v], e[17] = r, e[18] = a, e[19] = v, e[20] = z, e[21] = F) : (z = e[20], F = e[21]), me(z, F);
  let $, q;
  e[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? ($ = {
    select: "month-year-selector"
  }, q = /* @__PURE__ */ l(pe, { sx: n.monthYearSelectInput }), e[22] = $, e[23] = q) : ($ = e[22], q = e[23]);
  let f;
  e[24] !== se ? (f = se.map(we), e[24] = se, e[25] = f) : f = e[25];
  let h;
  e[26] !== c || e[27] !== f ? (h = /* @__PURE__ */ l(xe, { id: "month-select", value: c, onChange: Ye, displayEmpty: !0, classes: $, input: q, sx: n.monthYearSelectBox, children: f }), e[26] = c, e[27] = f, e[28] = h) : h = e[28];
  let G, J;
  e[29] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (G = {
    select: "month-year-selector"
  }, J = /* @__PURE__ */ l(pe, { sx: n.monthYearSelectInput }), e[29] = G, e[30] = J) : (G = e[29], J = e[30]);
  let K;
  e[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (K = Pe.map(je), e[31] = K) : K = e[31];
  let d;
  e[32] !== o ? (d = /* @__PURE__ */ l(xe, { id: "year-select", value: o, onChange: be, displayEmpty: !0, classes: G, input: J, sx: n.monthYearSelectBox, children: K }), e[32] = o, e[33] = d) : d = e[33];
  let u;
  e[34] !== h || e[35] !== d ? (u = /* @__PURE__ */ Y(b, { sx: n.dateTimeSelectorsWrapper, children: [
    h,
    d
  ] }), e[34] = h, e[35] = d, e[36] = u) : u = e[36];
  let L;
  e[37] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (L = {
    display: "flex",
    alignItems: "center"
  }, e[37] = L) : L = e[37];
  let p;
  e[38] !== C || e[39] !== oe || e[40] !== le || e[41] !== te || e[42] !== c || e[43] !== r || e[44] !== ne || e[45] !== o ? (p = /* @__PURE__ */ l(Ae, { selectedDate: r, onDateChange: ge, month: c, year: o, minTime: te, maxTime: le, startDate: ne, endDate: oe, dateType: C }), e[38] = C, e[39] = oe, e[40] = le, e[41] = te, e[42] = c, e[43] = r, e[44] = ne, e[45] = o, e[46] = p) : p = e[46];
  let x;
  e[47] !== I || e[48] !== a || e[49] !== ee ? (x = !I && /* @__PURE__ */ l(Ee, { selectedTime: a, onTimeChange: Me, timeSlots: ee }), e[47] = I, e[48] = a, e[49] = ee, e[50] = x) : x = e[50];
  let y;
  e[51] !== p || e[52] !== x ? (y = /* @__PURE__ */ Y(b, { sx: L, children: [
    p,
    x
  ] }), e[51] = p, e[52] = x, e[53] = y) : y = e[53];
  let Q;
  e[54] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Q = /* @__PURE__ */ l(Se, { sx: {
    borderColor: "#D6D6D6"
  } }), e[54] = Q) : Q = e[54];
  let R;
  e[55] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (R = /* @__PURE__ */ l(Ie, { sx: n.icon }), e[55] = R) : R = e[55];
  let U;
  e[56] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (U = {
    fontSize: "12px",
    fontWeight: 500
  }, e[56] = U) : U = e[56];
  const re = C === "start" ? "Start Date" : "End Date";
  let S;
  e[57] !== re ? (S = /* @__PURE__ */ Y(b, { sx: n.datePickerContent, children: [
    R,
    /* @__PURE__ */ l(ye, { sx: U, children: re })
  ] }), e[57] = re, e[58] = S) : S = e[58];
  let V;
  e[59] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (V = /* @__PURE__ */ l(Se, { orientation: "vertical", sx: n.verticalDivider }), e[59] = V) : V = e[59];
  let _;
  e[60] !== ie || e[61] !== t ? (_ = t.format(ie), e[60] = ie, e[61] = t, e[62] = _) : _ = e[62];
  let D;
  e[63] !== _ ? (D = /* @__PURE__ */ l(ye, { sx: n.formattedDateText, children: _ }), e[63] = _, e[64] = D) : D = e[64];
  let g;
  e[65] !== S || e[66] !== D ? (g = /* @__PURE__ */ Y(b, { sx: n.datePickerContainer, children: [
    S,
    V,
    D
  ] }), e[65] = S, e[66] = D, e[67] = g) : g = e[67];
  let X;
  return e[68] !== u || e[69] !== y || e[70] !== g ? (X = /* @__PURE__ */ Y(b, { sx: n.dateTimeSelectorContainer, children: [
    u,
    y,
    Q,
    g
  ] }), e[68] = u, e[69] = y, e[70] = g, e[71] = X) : X = e[71], X;
};
function we(s, e) {
  return /* @__PURE__ */ l(De, { sx: n.monthYearMenuItem, value: e.toString(), children: s }, e);
}
function je(s, e) {
  return /* @__PURE__ */ l(De, { sx: n.monthYearMenuItem, value: s.toString(), children: s }, e);
}
export {
  Ge as DateTimeSelectorMenu
};
